import { useCallback, useEffect, useState } from "react";
import { Button, Modal as BootstrapModal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useGetDomain } from "../../common/Hooks";
import Deployment from "../../services/deployment";
import Environment from "../../services/environment";
import PubSub from "../../services/PubSub";
import Setting from "../../services/setting";
import DeploymentSelector from "./DeploymentSelector";

const MigrateDeploymentSettings = ({ show, onCancel, destinationDeploymentId, destinationSettingsSetId }) => {
    const [translate] = useTranslation();
    const [domain] = useGetDomain();
    const [environments, setEnvironments] = useState([]);
    const [sourceDeploymentId, setSourceDeploymentId] = useState("");
    const [loadingMigration, setLoadingMigration] = useState(false);

    const [allDeployments, setAllDeployments] = useState([]);

    const migrateSettings = useCallback(async () => {
        let sourceId;
        setLoadingMigration(true);

        allDeployments.forEach(deployment => {
            if (deployment._id === sourceDeploymentId) {
                sourceId = deployment.settingsSet
            }
        });

        const settingsResponse = await Setting.migrateSettings(sourceId, destinationSettingsSetId, "deployment", sourceDeploymentId, destinationDeploymentId);
        if (!settingsResponse.error) {
            const response = await Deployment.migrateDeployment(sourceDeploymentId, destinationDeploymentId);
            if (!response.error) {
                PubSub.publish("refresh-deployment");
                onCancel();
            }
        }

        setLoadingMigration(false);
    }, [allDeployments, sourceDeploymentId, destinationDeploymentId, destinationSettingsSetId, onCancel]);

    const getAllEnvironments = useCallback(async () => {
        const response = await Environment.getAllEnvironmentsInDomain(domain._id);
        setEnvironments(response.data);
    }, [domain?._id, setEnvironments]);

    useEffect(() => {
        if (show) {
            getAllEnvironments();
        }
    }, [allDeployments, getAllEnvironments, show]);

    return (
        <BootstrapModal show={show} backdrop="static">
            <BootstrapModal.Header className="h5 text-secondary">{translate("OTM_LOAD_VALUES_SETTINGS")}</BootstrapModal.Header>
            <BootstrapModal.Body>
                <DeploymentSelector environments={environments}
                    envHeading="OTM_SOURCE_ENVIRONMENT"
                    deploymentHeading="OTM_SOURCE_DEPLOYMENT"
                    onDeploymentSelect={setSourceDeploymentId} exclude={destinationDeploymentId}
                    setAllDeployments={setAllDeployments} />
            </BootstrapModal.Body>
            <BootstrapModal.Footer>
                <Button onClick={migrateSettings} className="btn-sm"
                    disabled={!sourceDeploymentId || !destinationDeploymentId || loadingMigration}>
                    {translate("OTM_LOAD")}
                </Button>
                <Button onClick={onCancel} variant="secondary" className="btn-sm">{translate("OTM_CANCEL")}</Button>
            </BootstrapModal.Footer>
        </BootstrapModal>
    );
};

export default MigrateDeploymentSettings;